<template>
  <div
    class="flex flex-col gap-[24px] w-full h-fit bg-white border border-grays-400 rounded py-[22px] pl-[16px] pr-[36px]"
  >
    <!-- Intro/Edit -->
    <div class="flex flex-col md:flex-row w-full h-fit md:items-center gap-2">
      <h3 class="flex-1 text-xl font-medium text-primary-700 min-h-[36px]">
        פרופיל משפחתי
      </h3>
      <span
        v-if="profileData.id"
        class="bg-primary-100 text-primary-700 rounded-full px-3 py-1 text-sm font-bold w-fit"
        style="direction: ltr"
      >
        מזהה לקוח: {{ profileData.id }}
      </span>
    </div>
    <h3 class="flex-1 text-base font-medium text-grays-800 min-h-[24px]">
      פרטים אישיים
    </h3>
    <div class="flex flex-col">
      <!-- Edit fields -->
      <div class="flex flex-col w-full gap-[14px]">
        <div class="lg:flex flex-row w-full gap-[20px]">
          <input-default
            :error="v$.lname.$error"
            :errorMessage="v$.lname.$errors[0]?.$message"
            :label="'שם משפחה'"
            :model-value="lname"
            @update:model-value="setLname"
          />
          <input-default
            :error="v$.fname.$error"
            :errorMessage="v$.fname.$errors[0]?.$message"
            :label="'שם פרטי'"
            :model-value="fname"
            @update:model-value="setFname"
          />
          <input-default
            :error="v$.idNumber.$error"
            :errorMessage="v$.idNumber.$errors[0]?.$message"
            :label="'תעודת זהות'"
            :model-value="idNumber"
            @update:model-value="setIdNumber"
          />
        </div>
        <div class="md:flex flex-row w-full gap-[20px]">
          <input-default
            :error="v$.city.$error"
            :errorMessage="v$.city.$errors[0]?.$message"
            :label="'עיר'"
            :model-value="city"
            @update:model-value="setCity"
          />
          <input-default
            :error="v$.street.$error"
            :errorMessage="v$.street.$errors[0]?.$message"
            :label="'רחוב'"
            :model-value="street"
            @update:model-value="setStreet"
          />
        </div>
      </div>
    </div>
    <!--Add/Edit phones -->
    <div class="flex flex-col w-full gap-[16px]">
      <p class="text-grays-800 text-base font-medium">
        יצירת קשר <span class="text-sm text-grays-700"> טלפון אחד חובה</span>
      </p>
      <div class="w-fit gap-[20px] grid grid-cols-1 lg:grid-cols-3">
        <div
          v-for="(phoneNumber, index) in allPhoneNumbers"
          :key="index"
          class="w-fit flex gap-4"
        >
          <input-default
            :error="
              (index === 0
                ? !this.v$.allPhoneNumbers.firstPhoneRequire.$response
                : false) ||
              (v$.allPhoneNumbers.$each.$response.$errors
                ? !!v$.allPhoneNumbers.$each.$response.$errors[index].tel.length
                : false)
            "
            :errorMessage="
              index === 0 &&
              !this.v$.allPhoneNumbers.firstPhoneRequire.$response
                ? this.v$.allPhoneNumbers.firstPhoneRequire.$message.toString()
                : v$.allPhoneNumbers.$each.$response.$errors &&
                  v$.allPhoneNumbers.$each.$response.$errors[index].tel.length
                ? v$.allPhoneNumbers.$each.$response.$errors[index].tel[0]
                    .$message
                : ''
            "
            :label="'טלפון ' + (index + 1)"
            :model-value="phoneNumber.tel"
            @update:model-value="updatePhoneNumber(index, $event)"
          />
          <button
            v-if="allPhoneNumbers.length > 1"
            class="mt-8 h-fit"
            @click="deletePhone(index)"
          >
            <span class="material-symbols-rounded text-lg text-grays-800"
              >delete</span
            >
          </button>
        </div>
        <button-text class="mt-[25px]" @click="addNewPhone">
          <span class="material-symbols-rounded text-lg">add</span>
          עוד מספר טלפון
        </button-text>
      </div>
    </div>
    <error-block v-if="requestError" :error-message="errorMessage" />
    <!-- Save changes -->
    <div class="flex flex-col items-end">
      <button-secondary :disabled="!newChanges" @click="handleSave">
        {{ isLoading ? "Loading" : "לעדכן פרטים" }}
      </button-secondary>
    </div>
  </div>
</template>

<script>
import useValidate from "@vuelidate/core";
import { userValidation } from "@/validation/User";
import { mapGetters, mapMutations } from "vuex";
import axiosInstance from "../../helpers/axios.js";
import InputDefault from "@/components/Global/InputDefault.vue";
import ButtonText from "@/components/Global/ButtonText.vue";
import ErrorBlock from "@/components/Global/ErrorBlock.vue";
import ButtonSecondary from "@/components/Global/ButtonSecondary.vue";
import ButtonIcon from "@/components/Global/ButtonIcon.vue";

export default {
  name: "personal-details-card",
  components: {
    ButtonIcon,
    ButtonSecondary,
    ErrorBlock,
    ButtonText,
    InputDefault,
  },
  props: {
    profileData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      v$: useValidate(),
      isLoading: false,
      requestError: false,
      validateNewPhones: false,
      newChanges: false,
      originalProfile: {},
      errorMessage: "asssas",
    };
  },
  validations() {
    return {
      idNumber: userValidation.idNumber,
      fname: userValidation.fname,
      lname: userValidation.lname,
      street: userValidation.street,
      city: userValidation.city,
      allPhoneNumbers: userValidation.allPhoneNumbers,
    };
  },
  methods: {
    ...mapMutations({
      setFname: "user/setFname",
      setLname: "user/setLname",
      setIdNumber: "user/setIdNumber",
      setStreet: "user/setStreet",
      setCity: "user/setCity",
      setAllPhoneNumbers: "user/setAllPhoneNumbers",
      setFullName: "user/setFullName",
      addPhone: "user/addPhone",
      deleteAllNullPhoneNumbers: "user/deleteAllNullPhoneNumbers",
    }),
    deletePhone(index) {
      this.allPhoneNumbers.splice(index, 1);
      this.checkForChanges();
    },
    updatePhoneNumber(index, value) {
      this.setAllPhoneNumbers({ index, value });
      this.checkForChanges();
    },
    addNewPhone() {
      this.addPhone({ tel: "", no_msg: 0 });
      this.checkForChanges();
    },
    async handleSave() {
      this.v$.$validate();
      if (this.allPhoneNumbers.length === 0) {
        this.addPhone({ tel: "", no_msg: 0 });
      }
      if (!this.v$.$error) {
        this.deleteAllNullPhoneNumbers();
        this.isLoading = true;
        try {
          const modifiedPhone = this.allPhoneNumbers.map((phone) => {
            let { tel, no_msg } = phone;
            return { send_remind: no_msg || 0, phone: tel.toString() };
          });
          const dataForm = {
            tzl: this.idNumber,
            fname: this.fname,
            lname: this.lname,
            street: this.street,
            city: this.city,
            allPhoneNumbers: modifiedPhone,
          };
          const { data } = await axiosInstance.put("/clients", dataForm);
          this.setFullName(data.user.full_name);
          this.requestError = false;
          this.newChanges = false; // Reset after saving
          this.originalProfile = { ...dataForm }; // Update the original profile to the saved state
        } catch (e) {
          this.errorMessage = e.response?.data?.message || "";
          this.requestError = true;
        } finally {
          this.isLoading = false;
        }
      }
    },
    checkForChanges() {
      const { idNumber, fname, lname, street, city, allPhoneNumbers } = this;
      const original = this.originalProfile || {};

      const hasFieldChanged =
        idNumber !== original.tzl ||
        fname !== original.fname ||
        lname !== original.lname ||
        street !== original.street ||
        city !== original.city;

      const getFilteredPhoneNumbers = (phones = []) =>
        phones.map((phone) => phone.tel).filter(Boolean);
      const phoneNumbersChanged =
        JSON.stringify(getFilteredPhoneNumbers(allPhoneNumbers)) !==
        JSON.stringify(getFilteredPhoneNumbers(original.phones));

      this.newChanges = hasFieldChanged || phoneNumbersChanged;
    },
  },
  computed: {
    ...mapGetters({
      lname: "user/getLname",
      fname: "user/getFname",
      idNumber: "user/getIdNumber",
      street: "user/getStreet",
      city: "user/getCity",
      allPhoneNumbers: "user/getAllPhoneNumbers",
    }),
  },
  watch: {
    profileData: {
      deep: true,
      handler(updatedData) {
        this.setFname(updatedData.fname);
        this.setLname(updatedData.lname);
        this.setIdNumber(updatedData.tzl);
        this.setStreet(updatedData.street);
        this.setCity(updatedData.city);
        this.originalProfile = { ...updatedData }; // Update original profile when new data is loaded
      },
    },
    // Watch individual fields to detect changes
    fname() {
      this.checkForChanges();
    },
    lname() {
      this.checkForChanges();
    },
    idNumber() {
      this.checkForChanges();
    },
    street() {
      this.checkForChanges();
    },
    city() {
      this.checkForChanges();
    },
    allPhoneNumbers: {
      deep: true,
      handler() {
        this.checkForChanges();
      },
    },
  },
};
</script>

<style>
</style>